import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { component, property } from '../../../concepts/objects';
import { Physical, PotentialInteraction } from '../../canvas/entities/Physical';
import { RectangularPhysical } from '../../canvas/entities/RectangularPhysical';
import { Resizable } from '../../canvas/entities/Resizable';
import { Snappable } from '../../canvas/entities/Snappable';
import { PropertyStripLayout } from '../../canvas/properties/PropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Playable } from './Playable';
import { VideoController } from './VideoController';

const invocation = defineCommand(
    'nativeVideoInvoke',
    'NativeVideo Invoke',
    (r, [id]: [string]) => {
        r.call(VideoController).playOrStop(id);
    },
    [],
);

const propertyLayout = PropertyStripLayout<NativeVideo>((d, s, o, w, a) => [
    //
    // Controls
    w.createButton({
        active: a.get('controls'),
        // image: 'deqo://icons/d2/text-wrap',
        text: 'Controls',
        onAction() {
            o.update(() => a.set('controls', x => !x));
            this.update({ active: !a.get('controls') });
        }
    }),
    //
    // Loop
    w.createButton({
        active: a.get('loop'),
        // image: 'deqo://icons/d2/text-wrap',
        text: 'Loop',
        onAction() {
            o.update(() => a.set('loop', x => !x));
            this.update({ active: !a.get('loop') });
        }
    }),
    ...lockAndMoreLayout(d, s, o, w, a),
]);


const nativeVideoDef = {
    name: 'NativeVideo',
    // mutation: graphicMutate,
    invocation,
    implements: [Physical, Resizable, Playable, Snappable]
};

@component(nativeVideoDef)
export class NativeVideo extends RectangularPhysical implements Snappable {

    public get boundary() {
        return true;
    }

    public get shouldSnap() {
        return true;
    }

    @property({ type: 'boolean', default: true })
    public controls!: boolean;

    @property({ type: 'boolean', default: false })
    public loop!: boolean;

    @property({ type: 'string' })
    public url!: string;

    public getPlayer() {
        return document.querySelector(`[data-video-src="${this.id}"]`) as HTMLVideoElement;
    }

    public testInteraction({ type, mpt, selected }: PotentialInteraction): [boolean, string] {
        if (!this.localBounds.contains(this.toRelative(mpt))) return [false, 'none'];
        if (type === 'invoke') {
            if (selected || !this.controls) {
                return [false, 'none'];
            }
        }
        return [true, 'default'];
    }

}

